
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  const { t } = useTranslation();

  const values = [
    {
      icon: 'ri-target-line',
      title: t('accuracy'),
      description: t('accuracyText'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('confidentiality'),
      description: t('confidentialityText'),
    },
    {
      icon: 'ri-time-line',
      title: t('reliability'),
      description: t('reliabilityText'),
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
              {t('aboutPageTitle')}
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
              {t('aboutPageContent')}
            </p>
          </div>
        </div>
      </section>

      {/* Professional Image Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/e9b5bcc2ee5304cf6abe9f1074435c89/1c2edfcfded53ffd18d0f8bf064e624d.jpeg"
                alt="Javier Vargas Carrillo - Professional Legal Translator"
                className="rounded-xl shadow-lg object-cover w-full h-96 object-top"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                {t('professionalExcellenceTitle')}
              </h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                {t('professionalExcellenceText1')}
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                {t('professionalExcellenceText2')}
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 bg-slate-700 text-white font-semibold rounded-lg hover:bg-slate-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('contactUs')}
                <i className="ri-arrow-right-line ml-2 w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
              {t('mission')}
            </h2>
            <p className="text-xl text-slate-600 max-w-4xl mx-auto leading-relaxed">
              {t('missionText')}
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              {t('values')}
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center p-8 bg-slate-50 rounded-xl">
                <div className="w-16 h-16 bg-slate-700 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-2xl text-white w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-xl font-semibold text-slate-800 mb-4">
                  {value.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="py-20 bg-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">7+</div>
              <div className="text-slate-300">Years of Experience</div>
            </div>
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">1000+</div>
              <div className="text-slate-300">Documents Translated</div>
            </div>
            <div className="text-white">
              <div className="text-4xl font-bold mb-2">100%</div>
              <div className="text-slate-300">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            {t('ctaTitle')}
          </h2>
          <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
            {t('ctaSubtitle')}
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('ctaButton')}
            <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
